// @flow
import type { Action } from '../reducers'

export const FILTER_DOCUMENTS = 'FILTER_DOCUMENTS'

export const clearFilters = (): Action => ({
  type: FILTER_DOCUMENTS,
  payload: [{
    value: [],
    property: 'tags',
  }, {
    value: null,
    property: 'search',
  }]
})

export const filterDocumentsByTag = (tags: Array<*>): Action => ({
  type: FILTER_DOCUMENTS,
  payload: {
    value: tags,
    property: 'tags',
  }
})

export const filterDocumentsBySearch = (search: string): Action => ({
  type: FILTER_DOCUMENTS,
  payload: {
    value: search,
    property: 'search'
  }
})